import { QueryClient } from '@tanstack/react-query';

// Intervalo de atualização automática das telas abertas (listas, dashboard).
// Hooks de formulário/dados de referência desligam com `refetchInterval: false`.
export const AUTO_REFRESH_MS = 30 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,            // Renavegar dentro de 30s usa o cache, sem nova chamada
      gcTime: 10 * 60 * 1000,          // Mantém o cache por mais tempo do que o staleTime
      refetchOnWindowFocus: false,     // NÃO refetch ao focar
      // true = refaz ao montar SÓ se o dado estiver stale (o cache aparece na
      // hora e atualiza em segundo plano). false seria "nunca": a tela ficava
      // presa ao cache por até 10min (gcTime).
      refetchOnMount: true,
      refetchOnReconnect: true,        // Refetch ao reconectar
      retry: 1,
      refetchInterval: AUTO_REFRESH_MS,
      refetchIntervalInBackground: false, // Pausa com a aba oculta/minimizada
    },
    mutations: {
      retry: 1,
    },
  },
});